// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__6VBGP","productName":"Table_productName__1b4cU"};